<template>
<div class="card">
  <div class="card-header">
    <span class="card-title">{{title}}</span>
    <slot name="action"></slot>
  </div>
  <div class="card-content">
    <Loading :show="loading"></Loading>
    <slot name="content"></slot>
  </div>
</div>
</template>

<script>

import Loading from "components/Loading";
export default {
  name: "DashBoardCard",
  components: {Loading},
  props: {
    title: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
}
</script>

<style scoped lang="scss">
.card {
  max-height: 400px;
  background-color: #EDEDF2;
  border: 1px solid #EDEDF2;
  display: flex;
  gap: 1px;
  border-radius: 5px;
  flex-direction: column;
  .card-header {
    padding-left: 10px;
    gap: 10px;
    display: flex;
    background-color: #F6F6FA;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    border-radius: 5px 5px 0 0;
    .card-title {
      font-size: 14px;
      font-weight: bold;
      color: black;
    }
  }
  .card-content {
    position: relative;
    display: flex;
    background-color: white;
    flex: 1;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    border-radius: 0 0 5px 5px;
  }
}
</style>